// extracted by mini-css-extract-plugin
export default {"times":"ChangeSummary-module--times--ab4b6","original":"ChangeSummary-module--original--ad609"};